module.exports = __webpack_public_path__ + "static/media/zmail_logo.ecfd66f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zmail_logo.png
// module id = 115
// module chunks = 0